<div class="content-body">
  <div class="content-title">Overview</div>
  <div class="question">Q: What are Monitoring Portal Directions and Stored Procedures?</div>
  <div class="description">
     Monitoring Portal Directions and Stored Operator Procedures provide essential information and guided response actions for operators responsible for monitoring a specific location. <br/><br/>They help ensure that video monitoring services are conducted consistently with customer expectations.</div>
  <hr/>
  <div class="question">Q: When are Monitoring Portal Directions displayed to operators?</div>
  <div class="description">Monitoring Portal Directions are not displayed to operators until a monitoring center approval authority has finalized them and are only available in the new MPv2 interface.</div>
  <hr/>
  <div class="question">📌 Note - Monitoring Portal Directions</div>
  <div class="description">
     Monitoring portal directions are only supported in MPv2.
  </div>
</div>
